import { getPalette } from 'owa-theme';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';

/**
 * Gets the compact card action style
 * @param colorScheme the color scheme of the calendar
 */
export default function getCompactCardActionStyle(colorScheme?: ColorScheme): IButtonStyles {
    const buttonColor = (colorScheme && colorScheme.calPrimary) || getPalette().themePrimary;

    const buttonHoverColor = (colorScheme && colorScheme.calDarker) || getPalette().themeDarker;

    return {
        root: {
            color: buttonColor,
        },

        rootHovered: {
            color: buttonHoverColor,
        },

        rootPressed: {
            backgroundColor: buttonHoverColor,
        },
    };
}
